import { defineStore } from "pinia"

import axiosInstance from "@/http.js"

const axios = axiosInstance

function withoutTrailingSlash(url) {
  return String(url || "").replace(/\/+$/, "")
}

const CLEARFXAI_API_URL = withoutTrailingSlash(process.env.VUE_APP_CLEARFXAI_API_URL)
const APIVERSION = process.env.VUE_APP_API_VERSION
const SECRETKEY = process.env.VUE_APP_SECRETKEY

const API_PATH = `v${APIVERSION}/clearfxai`

// One interaction behavior toggle kept in code, not env.
export const INTERACTION_CONSUME_ON_LOAD = false

export const INTERACTION_API_BASE_URL = `${CLEARFXAI_API_URL}/apiemail/${API_PATH}`

function interactionUrl(pathSuffix) {
  return `${INTERACTION_API_BASE_URL}${pathSuffix}`
}

export const useInteractionEmailStore = defineStore("interactionEmail", {
  actions: {
    // The operation's documents are already on the platform, so the e-mail
    // service reads them itself rather than being handed a second copy.
    requestOperationApproval({ operationId, brokerId } = {}) {
      if (!operationId) {
        return Promise.reject(new Error("Missing operationId"))
      }
      if (!brokerId) {
        return Promise.reject(new Error("Missing brokerId"))
      }

      return axios.post(interactionUrl("/email/operation"), {
        operation_id: operationId,
        broker_id: brokerId
      }, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    }
  }
})

export const useOtpLinkStore = defineStore("otpLink", {
  state: () => ({
    loading: false,
    lastValidation: null,
    lastSubmission: null,
    lastError: null
  }),
  actions: {
    validateInteractionToken(token) {
      this.loading = true
      this.lastError = null

      return axios.get(interactionUrl("/inspect"), { params: { token } })
        .then((response) => {
          this.lastValidation = response.data
          return response
        })
        .catch((error) => {
          this.lastError = error
          throw error
        })
        .finally(() => {
          this.loading = false
        })
    },
    confirmInteraction({ token }) {
      this.loading = true
      this.lastError = null

      return axios.post(interactionUrl("/confirm"), {
        token
      })
        .then((response) => {
          this.lastSubmission = response.data
          return response
        })
        .catch((error) => {
          this.lastError = error
          throw error
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitInteractionQuote({ token, price }) {
      this.loading = true
      this.lastError = null

      return axios.post(interactionUrl("/submit_price"), {
        token,
        price
      })
        .then((response) => {
          this.lastSubmission = response.data
          return response
        })
        .catch((error) => {
          this.lastError = error
          throw error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
})
